import { HeaderWrapper } from './styles'
import Title from 'components/Title'
import ChooseCenter from 'components/ChooseCenter'
import { Address, User } from 'globals/models/User'

interface IProps {
  title: string,
  backlink?: string,
  currentUser: User,
  currentCenters: Address[]
}

const Header = (props: IProps) => {
  const { title, backlink, currentUser, currentCenters } = props

  return (
    <HeaderWrapper>
      <Title
        title={title}
        backlink={backlink}
      />

      <ChooseCenter
        addresses={currentUser.addresses}
        currentCenters={currentCenters}
      />
    </HeaderWrapper>
  )
}

export default Header
